<template>
    <div class="cover--img">

    </div>
    
</template>

<script>
    export default {
        name: "cover-img"
    }
</script>

<style scoped lang="scss">
    .cover--img {
        background: url("/static/img/cover-img.png") no-repeat;
        min-height: 100vh;
    }

</style>


// WEBPACK FOOTER //
// src/components/CoverImg.vue